import { useContext } from 'react'
import { generatePath, To } from 'react-router-dom'

import { Table, useFilteredData } from 'components/Table'
import { AdUnitBidderSlice } from 'features/inventory/ad-unit/forms/PrebidStackForm'
import { PrebidStackFormContext } from 'features/inventory/ad-unit/forms/PrebidStackForm/context/PrebidStackFormContext'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { ROUTES } from 'routes'
import { BiddersTableProps } from './types'
import { useColumns } from './useColumns'

export const BiddersTable = ({ filters }: BiddersTableProps): JSX.Element => {
  const { workspaceId } = useWorkspaceParam()
  const { adUnitBidders } = useContext(PrebidStackFormContext)
  const columns = useColumns()
  const data = useFilteredData<AdUnitBidderSlice>({
    data: adUnitBidders,
    filterBy: ['code', 'name'],
    filters,
  })

  const ability = useAbility()
  const cannotAccessPrebidBidders = ability.cannot('access', 'GlobalSetupPage-prebid-bidders-edit')

  if (!adUnitBidders) {
    throw new Error('Ad unit bidders are required')
  }

  const handleRowClick = ({ workspaceBidderId }: AdUnitBidderSlice): To =>
    generatePath(ROUTES.GLOBAL_SETUP.PREBID.BIDDERS.EDIT, {
      id: workspaceBidderId,
      tab: 'general',
      workspaceId,
    })

  return (
    <Table<AdUnitBidderSlice>
      columns={columns}
      data={data}
      data-cy='ad-unit-bidders-table'
      onClickRow={
        cannotAccessPrebidBidders ? undefined : adUnitBidder => handleRowClick(adUnitBidder)
      }
    />
  )
}
